import React from "react";
import COLORS from "scss/colors.module.scss";
import MenuItem from "@material-ui/core/MenuItem";

export const OptionFormatter = (name) => (
  <div
    style={{
      display: "flex",
      minWidth: 200,
    }}
  >
    <MenuItem
      style={{
        color: COLORS.TEXT_COLOR,
        cursor: "pointer",
        marginTop: 5,
        marginBottom: 5,
        paddingLeft: 20,
      }}
      className="w-100 h-100"
    >
      {name}
    </MenuItem>
  </div>
);

export const colourStyles = {
  control: (styles) => ({
    marginLeft: 8,
    marginRight: 8,
    minWidth: 250,
  }),
  menu: () => ({
    boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
  }),
  valueContainer: (styles) => ({
    ...styles,
    cursor: "text",
  }),
  option: (styles, state) => ({
    ...styles,
    height: 30,
    backgroundColor: COLORS.PRIMARY_COLOR,
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    cursor: "pointer",
  }),
};
